export const GRADIENT                = "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))";
export const TEMPLATE_AVATAR_GRAD    = "linear-gradient(135deg, #7e2537 0%, #7e2555 50%, #401219 100%)";
export const ACCENT           = "rgb(90, 28, 47)";
export const TYPE_OPTS        = ["All", "Template", "Plugin"];
export const SORT_OPTS        = ["Featured", "Newest", "Price: Low–High", "Price: High–Low", "Top Rated"];
export const PLUGINS_PER_PAGE = 10;
export const TPLS_PER_PAGE    = 12;
export const ALL_PER_PAGE     = 12;

export const BADGE_STYLES = {
  Free:          { bg: "#e6f4ea", color: "#2e7d32" },
  Popular:       { bg: "#e3f2fd", color: "#1565c0" },
  "Best Seller": { bg: "#fff3e0", color: "#e65100" },
  Pro:           { bg: "#f3e5f5", color: "#6a1b9a" },
};

